import { a as o } from "../../../chunk-OA3DH5LS-40f95340.js";
const e = o("FileUploader").parts(
  "container",
  "content",
  "description",
  "descriptionContainer",
  "drag",
  "dropzone",
  "dropzoneFailed",
  "dropzoneFailedDrag",
  "errorMessage",
  "errorMessageContainer",
  "heading",
  "icon",
  "or",
  "root",
  "spinnerContainer"
);
export {
  e as FileUploaderAnatomy
};
//# sourceMappingURL=FileUploader.anatomy.es.js.map
